import { muiTheme } from "@/styles/theme";
import { Box, Checkbox } from "@mui/material";
import { Check, Minus } from "lucide-react";

export interface CheckboxProps {
  checked?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
  disabled?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  indeterminate?: boolean;
}

function CustomCheckbox({
  checked,
  onChange,
  disabled,
  inputProps,
  indeterminate,
}: CheckboxProps) {
  return (
    <Checkbox
      indeterminate={indeterminate}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      inputProps={inputProps}
      icon={
        <Box
          sx={{
            width: "20px",
            height: "20px",
            borderRadius: "4px",
            border: `2px solid #696F7B`,
          }}
        />
      }
      indeterminateIcon={
        <Box
          sx={{
            width: "20px",
            height: "20px",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: `2px solid ${muiTheme.colorSchemes.light.palette.primary[500]}`,
            backgroundColor: muiTheme.colorSchemes.light.palette.primary[500],
          }}
        >
          <Minus
            color="white"
            style={{
              width: "16px",
              height: "16px",
            }}
          />
        </Box>
      }
      checkedIcon={
        <Box
          sx={{
            width: "20px",
            height: "20px",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: muiTheme.colorSchemes.light.palette.primary[500],
          }}
        >
          <Check
            color="white"
            style={{
              width: "16px",
              height: "16px",
            }}
          />
        </Box>
      }
    />
  );
}

export default CustomCheckbox;
